import axios from "axios";
import {access_token, BASE_URL, BASE_URL_1, BASE_URL_2, RECIPE_BASE_URL} from './constants';
//import { getToken, getRefreshToken } from "../utils/auth";


const service = axios.create({
  baseURL: BASE_URL, // api base_url
  //timeout: 5000, // request timeout
});

service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    //if (store.getState().user.token) {
      if(access_token()){
        if(config.url.split('?').length===1){
          config.url=`${config.url}?access_token=${access_token()}`;
        }else{
          config.url=`${config.url}&access_token=${access_token()}`;
        }
      //config.headers.Authorization = getToken();
      //config.headers['access_token'] = access_token();
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => response, 
  (error) => {
    console.log("err" + error); // for debug
    const { status } = error.response;
    if (status === 401) {
      if(error.response.config.url==='/login'){
        return;
      }
      let refresh_token = sessionStorage.getItem('refresh_token')
      if(refresh_token){
        return new Promise((resolve)=> getTokenByRefreshToken(refresh_token).then((res)=>{
          console.log('refresh_token Info:', res)
          if(res.status!==200){
              sessionStorage.clear();
              window.location.replace('/login');
           }else{
              sessionStorage.setItem('access_token', res.data.access_token);
              sessionStorage.setItem('refresh_token', res.data.refresh_token);
              const {config}=error;
              let url=config.url;
              config.url=url.replace(url.split('&').pop(),'access_token='+res.data.access_token);
              return resolve(service(config));
           }
        }));
      }else{
        sessionStorage.clear();
        window.location.replace('/login');
      }
    }else{
      return Promise.reject(error.toJSON());
    }
  }
);

export const recipeService = axios.create({
  baseURL: RECIPE_BASE_URL, // api base_url
  //timeout: 5000, // request timeout
});

recipeService.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

const getTokenByRefreshToken=(refresh_token)=>{
  return axios({
    method: 'POST',
    headers: {
      'Authorization': 'Basic ' + btoa('my-trusted-client:secret'),
      'Content-Type': 'application/x-www-form-urlencoded'
  },
    url:`${BASE_URL}/oauth/token?grant_type=refresh_token&refresh_token=${refresh_token}`,
  })

}
export default service;



// WEBPACK FOOTER //
// ./src/server/request.js